import React from 'react'
import {
  Box, Text, ImageLoader,
} from '@usap/uicomponents'
import SetKitDisplay from '../../../SetKitDisplay'
import { minHeightCss, fontMinHeightCss } from '../constant'
import ReasonsListWMO from './ReasonListWMO'
import ImageUploadWMO from './ImageUploadWMO'
import { 
  Container,
  OrderInfo,
  OrderInfoFlexBox,
  Quantity,
  TextWrapper, 
  TextWrapper2, 
  ItemTotal,
  ReturnRequest, 
  ReturnDetailsContainer 
} from "../style/OrderItemWMO.css"

const OrderItemWMO = ({
  orderItems,
  isDesktop,
  selectedImages,
  filesUpload,
  reasonLabel,
  successData,
  type
}) => {

  return (
    <>
      {orderItems.map((items) => (
        <Container
          key={items.order_item_id}
          pad="16px"
        >
          <OrderInfo
            key={`Box2${items.order_item_id}`}
          >
            <OrderInfoFlexBox>
              <Box
                key={`Box3${items.order_item_id}`}
                width="108px"
                style={{ minWidth: "108px "}}
              >
                <ImageLoader
                  key={`RMA${items.order_item_id}`}
                  width="100%"
                  height="100%"
                  src={items.ImageURL}
                  fit="contain"
                  alt={items.sku_title}
                  cloudinaryParams="h_125,w_125"
                  fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
                />
                <Quantity key={`txt4${items.order_item_id}`}>
                  QTY:
                  {' '}
                  {items.returnQty}
                </Quantity>
              </Box>
              <Box
                key={`Box4${items.order_item_id}`}
                direction="column"
              >
                <TextWrapper>
                  <Text
                    key={`txt1${items.order_item_id}`}
                    size="16px"
                    style={fontMinHeightCss}
                    dangerouslySetInnerHTML={{ __html: items.brandText }}
                  />
                  {" "}
                  <Text
                    key={`txt2${items.order_item_id}`}
                    size="16px"
                    style={minHeightCss}
                    dangerouslySetInnerHTML={{ __html: items.sku_title }}
                  />
                </TextWrapper>
                <TextWrapper2>
                  <Text key={`txt3${items.order_item_id}`} size="12px">
                    Part Number.:
                    {' '}
                    {items.sku}
                  </Text>
                  <Text key={`txt5${items.order_item_id}`} size="12px">
                    Unit Price:
                    {' '}
                    $
                    {parseFloat(items.list_price).toFixed(2)}
                  </Text>
                </TextWrapper2>
                <ItemTotal key={`txt6${items.order_item_id}`}>
                  Item Total:
                  {' '}
                  $
                  {(parseFloat(items.list_price) * items.returnQty).toFixed(2)}
                </ItemTotal>

                {isDesktop && items.parentSku && (
                  <Box key={`parentSku${items.order_item_id}`} pad={{ right: '16px', top: '16px' }} margin={{ bottom: "-16px"}}>
                    <SetKitDisplay
                      key={`hparentSKU${items.order_item_id}`}
                      parentSku={items.parentSku}
                      showPartNumber={false}
                      isWmoEnabled
                    />
                  </Box>
                )}
              </Box>
            </OrderInfoFlexBox>
            {!isDesktop && items.parentSku && (
              <Box key={`Box7${items.order_item_id}`} pad={{ right: '0px', top: '16px' }} margin={{ bottom: "-16px"}}>
                <SetKitDisplay
                  key={`hparentSKU2${items.order_item_id}`}
                  parentSku={items.parentSku}
                  showPartNumber={false}
                  isWmoEnabled
                />
              </Box>
            )}
          </OrderInfo>
          <ReturnRequest key={`txt7${items.order_item_id}`}>
            {type === "returns" ? 'Return Request ID:' : 'Warranty Claim ID:'} <strong>{successData}</strong> <em>* This is not your RMA number</em>
          </ReturnRequest>
          <ReturnDetailsContainer
            key={`Box6${items.order_item_id}`}
          >
            <ReasonsListWMO
              reasons={items.reasons}
              reasonLabel={reasonLabel}
            />
            <ImageUploadWMO
              sku={items.sku}
              selectedImages={selectedImages}
              filesUpload={filesUpload}
            />
          </ReturnDetailsContainer>
        </Container>
      ))}
    </>
  )
}

export default OrderItemWMO
